import { defineComponent as _defineComponent } from 'vue'
import { CourseReportItem } from '@/entities/trainings';
  import { hasSections } from '@/ui/helpers/trainingsHelper';
  import CourseReportTable from './CourseReportTable.vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CourseOutline',
  props: {
    items: {
      type: Array as () => Array<CourseReportItem>,
      required: true,
    },
  },
  setup(__props) {

  

return { __sfc: true,hasSections, CourseReportTable }
}

})